// export const getBaseTokenLogoURLByTokenSymbol =
// [
//   {
//     "type": "coin",
//     "chainId": 97,
//     "value": "0x0000000000000000000000000000000000000000",
//     "name": "BNB",
//     "label": "BNB",
//     "decimals": 18,
//     "logo": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xB8c77482e45F1F44dE1745F52C74426C631bDD52/logo.png"
//   },

//   {
//     "type": "token",
//     "value": "0xb8F320F62C7dF27fBB9a9050A6b75E3F01043912",
//     "chainId": 97,
//     "name": "BUSD Stablecoin",
//     "label": "BUSD",
//     "decimals": 18,
//     "logo": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x4Fabb145d64652a948d72533023f6E7A623C7C53/logo.png"

//   },

//   {
//     "type": "token",
//     "value": "0x818283230fD35A2605F4830f6bE6d950508F1329",
//     "chainId": 97,
//     "name": "Rexx",
//     "label": "FLAIR",
//     "decimals": 18,
//     "logo": require('../../images/flair.png')

//   },
//   {
//     "type": "token",
//     "name": "Tether USD",
//     "label": "USDT",
//     "value": "0x7ef95a0fee0dd31b22626fa2e10ee6a223f8a684",
//     "chainId": 97,
//     "decimals": 18,
//     "logo": "https://pancakeswap.finance/images/tokens/0x55d398326f99059fF775485246999027B3197955.png"
//   },
//   {
//     "type": "token",
//     "name": "Dai Token",
//     "label": "DAI",
//     "value": "0x8a9424745056Eb399FD19a0EC26A14316684e274",
//     "chainId": 97,
//     "decimals": 18,
//     "logo": "https://tokens.pancakeswap.finance/images/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3.png"
//   },

//   {
//     "type": "token",
//     "name": "CinemaDraft Token",
//     "label": "CD3D",
//     "value": "0xFd4C59960Ba11F34a978a737E63ff6ECa9aB4979",
//     "chainId": 97,
//     "decimals": 9,
//     "logo": "https://cd3d-silk.vercel.app/_next/image?url=%2F_next%2Fstatic%2Fimage%2Fpublic%2Fassets%2Fhomepage%2FCD3D-icon.a5ce81350528aa0476a4e4871660a9a9.svg&w=32&q=75"
//   },

//   {
//     "type": "token",
//     "name": "BTCB Token",
//     "label": "BTCB",
//     "value": "0x6ce8da28e2f864420840cf74474eff5fd80e65b8",
//     "chainId": 97,
//     "decimals": 18,
//     "logo": "https://pancakeswap.finance/images/tokens/0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c.png"
//   },

//       {
//         "type": "token",
//          "value": "0x4dfc8138c0e0a6e406e9d3699d997b905891a47e",
//         "chainId": 97,
//         "name": "LUNA2.0 ",
//         "label": "LUNA",
//         "decimals": 18,
//         "logo": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xB8c77482e45F1F44dE1745F52C74426C631bDD52/logo.png"
//       },

//    {
//     "type": "token",
//     "value": "0x9C6bD2e05c59B0B37594c7196c362C1F3ea2A2Fb",
//    "chainId": 97,
//    "name": "TestToken1",
//    "label": "TT1",
//    "decimals": 18,
//    "logo": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xB8c77482e45F1F44dE1745F52C74426C631bDD52/logo.png"
//  },

//     ]

export const getBaseTokenLogoURLByTokenSymbol = [
  {
    type: "coin",
    chainId: 56,
    value: "0x0000000000000000000000000000000000000000",
    address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    name: "BNB",
    label: "BNB",
    decimals: 18,
    logo: "data:image/png;base64,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",
  },
  {
    name: "WBNB Token",
    symbol: "WBNB",
    address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c.png",
    type: "token",
  },
  {
    name: "PancakeSwap Token",
    symbol: "CAKE",
    address: "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82.png",
    type: "token",
  },
  {
    name: "Binance Pegged BUSD",
    symbol: "BUSD",
    address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56.png",
    type: "token",
  },
  {
    name: "Binance Pegged USDT",
    symbol: "USDT",
    address: "0x55d398326f99059fF775485246999027B3197955",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x55d398326f99059fF775485246999027B3197955.png",
    type: "token",
  },
  {
    name: "Binance Pegged Bitcoin",
    symbol: "BTCB",
    address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c.png",
    type: "token",
  },
  {
    name: "Binance Pegged ETH",
    symbol: "ETH",
    address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x2170Ed0880ac9A755fd29B2688956BD959F933F8.png",
    type: "token",
  },
  {
    name: "Bunny Token",
    symbol: "BUNNY",
    address: "0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51.png",
    type: "token",
  },
  {
    name: "Venus Token",
    symbol: "XVS",
    address: "0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63.png",
    type: "token",
  },
  {
    name: "Alpaca",
    symbol: "ALPACA",
    address: "0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F.png",
    type: "token",
  },
  {
    name: "Polkadot Token",
    symbol: "DOT",
    address: "0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402.png",
    type: "token",
  },
  {
    name: "Refinable",
    symbol: "FINE",
    address: "0x4e6415a5727ea08aAE4580057187923aeC331227",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x4e6415a5727ea08aAE4580057187923aeC331227.png",
    type: "token",
  },
  {
    name: "Binance Pegged DAI",
    symbol: "DAI",
    address: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3.png",
    type: "token",
  },
  {
    name: "Binance Pegged USD Coin",
    symbol: "USDC",
    address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d.png",
    type: "token",
  },
  {
    name: "Cardano Token",
    symbol: "ADA",
    address: "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47.png",
    type: "token",
  },
  {
    name: "ALICE",
    symbol: "ALICE",
    address: "0xAC51066d7bEC65Dc4589368da368b212745d63E8",
    chainId: 56,
    decimals: 6,
    logo: "https://tokens.pancakeswap.finance/images/0xAC51066d7bEC65Dc4589368da368b212745d63E8.png",
    type: "token",
  },
  {
    name: "AlinX",
    symbol: "ALIX",
    address: "0xaF6Bd11A6F8f9c44b9D18f5FA116E403db599f8E",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xaF6Bd11A6F8f9c44b9D18f5FA116E403db599f8E/logo.png",
    type: "token",
  },
  {
    name: "AlphaToken",
    symbol: "ALPHA",
    address: "0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xa1faa113cbE53436Df28FF0aEe54275c13B40975.png",
    type: "token",
  },
  {
    name: "Altura",
    symbol: "ALU",
    address: "0x8263CD1601FE73C066bf49cc09841f35348e3be0",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8263CD1601FE73C066bf49cc09841f35348e3be0/logo.png",
    type: "token",
  },
  {
    name: "Automata",
    symbol: "ATA",
    address: "0xA2120b9e674d3fC3875f415A7DF52e382F141225",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xA2120b9e674d3fC3875f415A7DF52e382F141225.png",
    type: "token",
  },
  {
    name: "Cosmos Token",
    symbol: "ATOM",
    address: "0x0Eb3a705fc54725037CC9e008bDede697f62F335",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x0Eb3a705fc54725037CC9e008bDede697f62F335.png",
    type: "token",
  },
  {
    name: "Axie Infinity Shard",
    symbol: "AXS",
    address: "0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0.png",
    type: "token",
  },
  {
    name: "Baby Doge Coin",
    symbol: "BABYDOGE",
    address: "0xc748673057861a797275CD8A068AbB95A902e8de",
    chainId: 56,
    decimals: 9,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc748673057861a797275CD8A068AbB95A902e8de/logo.png",
    type: "token",
  },
  {
    name: "Bear",
    symbol: "BEAR",
    address: "0xc3EAE9b061Aa0e1B9BD3436080Dc57D2d63FEdc1",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc3EAE9b061Aa0e1B9BD3436080Dc57D2d63FEdc1/logo.png",
    type: "token",
  },
  {
    name: "Bella Protocol",
    symbol: "BEL",
    address: "0x8443f091997f06a61670B735ED92734F5628692F",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x8443f091997f06a61670B735ED92734F5628692F.png",
    type: "token",
  },
  {
    name: "BELT Token",
    symbol: "BELT",
    address: "0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f.png",
    type: "token",
  },
  {
    name: "Binemon",
    symbol: "BIN",
    address: "0xe56842Ed550Ff2794F010738554db45E60730371",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xe56842Ed550Ff2794F010738554db45E60730371/logo.png",
    type: "token",
  },
  {
    name: "Binamon",
    symbol: "BMON",
    address: "0x08ba0619b1e7A582E0BCe5BBE9843322C954C340",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x08ba0619b1e7A582E0BCe5BBE9843322C954C340.png",
    type: "token",
  },
  {
    name: "BunnyPark",
    symbol: "BP",
    address: "0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1.png",
    type: "token",
  },
  {
    name: "BSCPAD.com",
    symbol: "BSCPAD",
    address: "0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700.png",
    type: "token",
  },
  {
    name: "BitTorrent Old",
    symbol: "BTTOLD",
    address: "0x8595F9dA7b868b1822194fAEd312235E43007b49",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x8595F9dA7b868b1822194fAEd312235E43007b49.png",
    type: "token",
  },
  {
    name: "Coin98",
    symbol: "C98",
    address: "0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6.png",
    type: "token",
  },
  {
    name: "Chess",
    symbol: "CHESS",
    address: "0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6.png",
    type: "token",
  },
  {
    name: "Chroma",
    symbol: "CHR",
    address: "0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE",
    chainId: 56,
    decimals: 6,
    logo: "https://tokens.pancakeswap.finance/images/0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE.png",
    type: "token",
  },
  {
    name: "CP",
    symbol: "CP",
    address: "0x82C19905B036bf4E329740989DCF6aE441AE26c1",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x82C19905B036bf4E329740989DCF6aE441AE26c1/logo.png",
    type: "token",
  },
  {
    name: "DeRace Token",
    symbol: "DERC",
    address: "0x373E768f79c820aA441540d254dCA6d045c6d25b",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x373E768f79c820aA441540d254dCA6d045c6d25b/logo.png",
    type: "token",
  },
  {
    name: "DODO bird",
    symbol: "DODO",
    address: "0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2.png",
    type: "token",
  },
  {
    name: "Dogecoin",
    symbol: "DOGE",
    address: "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
    chainId: 56,
    decimals: 8,
    logo: "https://tokens.pancakeswap.finance/images/0xbA2aE424d960c26247Dd6c32edC70B295c744C43.png",
    type: "token",
  },
  {
    name: "My DeFi Pet Token",
    symbol: "DPET",
    address: "0xfb62AE373acA027177D1c18Ee0862817f9080d08",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xfb62AE373acA027177D1c18Ee0862817f9080d08/logo.png",
    type: "token",
  },
  {
    name: "DragonSlayer",
    symbol: "DRS",
    address: "0xc8E8ecB2A5B5d1eCFf007BF74d15A86434aA0c5C",
    chainId: 56,
    decimals: 9,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc8E8ecB2A5B5d1eCFf007BF74d15A86434aA0c5C/logo.png",
    type: "token",
  },
  {
    name: "Dvision",
    symbol: "DVI",
    address: "0x758FB037A375F17c7e195CC634D77dA4F554255B",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x758FB037A375F17c7e195CC634D77dA4F554255B.png",
    type: "token",
  },
  {
    name: "Etherconnect Coin",
    symbol: "ECC",
    address: "0x8D047F4F57A190C96c8b9704B39A1379E999D82B",
    chainId: 56,
    decimals: 8,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8D047F4F57A190C96c8b9704B39A1379E999D82B/logo.png",
    type: "token",
  },
  {
    name: "Ellipsis",
    symbol: "EPS",
    address: "0xA7f552078dcC247C2684336020c03648500C6d9F",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xA7f552078dcC247C2684336020c03648500C6d9F.png",
    type: "token",
  },
  {
    name: "FaraCrystal",
    symbol: "FARA",
    address: "0xF4Ed363144981D3A65f42e7D0DC54FF9EEf559A1",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xF4Ed363144981D3A65f42e7D0DC54FF9EEf559A1/logo.png",
    type: "token",
  },
  {
    name: "Formation Finance",
    symbol: "FORM",
    address: "0x25A528af62e56512A19ce8c3cAB427807c28CC19",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x25A528af62e56512A19ce8c3cAB427807c28CC19.png",
    type: "token",
  },
  {
    name: "Frontier Token",
    symbol: "FRONT",
    address: "0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b.png",
    type: "token",
  },
  {
    name: "StepHero",
    symbol: "HERO",
    address: "0xE8176d414560cFE1Bf82Fd73B986823B89E4F545",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xE8176d414560cFE1Bf82Fd73B986823B89E4F545.png",
    type: "token",
  },
  {
    name: "Metahero",
    symbol: "HERO",
    address: "0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13.png",
    type: "token",
  },
  {
    name: "Honey token",
    symbol: "HONEY",
    address: "0xFa363022816aBf82f18a9C2809dCd2BB393F6AC5",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xFa363022816aBf82f18a9C2809dCd2BB393F6AC5/logo.png",
    type: "token",
  },
  {
    name: "Hunny Token",
    symbol: "HUNNY",
    address: "0x565b72163f17849832A692A3c5928cc502f46D69",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x565b72163f17849832A692A3c5928cc502f46D69/logo.png",
    type: "token",
  },
  {
    name: "Injective Protocol",
    symbol: "INJ",
    address: "0xa2B726B1145A4773F68593CF171187d8EBe4d495",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xa2B726B1145A4773F68593CF171187d8EBe4d495.png",
    type: "token",
  },
  {
    name: "IoTeX Network",
    symbol: "IOTX",
    address: "0x9678E42ceBEb63F23197D726B29b1CB20d0064E5",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x9678E42ceBEb63F23197D726B29b1CB20d0064E5.png",
    type: "token",
  },
  {
    name: "Kaby Arena",
    symbol: "KABY",
    address: "0x02A40C048eE2607B5f5606e445CFc3633Fb20b58",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x02A40C048eE2607B5f5606e445CFc3633Fb20b58/logo.png",
    type: "token",
  },
  {
    name: "KmonCoin",
    symbol: "KMON",
    address: "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc732B6586A93b6B7CF5FeD3470808Bc74998224D/logo.png",
    type: "token",
  },
  {
    name: "Linear Token",
    symbol: "LINA",
    address: "0x762539b45A1dCcE3D36d080F74d1AED37844b878",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x762539b45A1dCcE3D36d080F74d1AED37844b878.png",
    type: "token",
  },
  {
    name: "ChainLink Token",
    symbol: "LINK",
    address: "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD.png",
    type: "token",
  },
  {
    name: "Mask Network",
    symbol: "MASK",
    address: "0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3.png",
    type: "token",
  },
  {
    name: "Mobox",
    symbol: "MBOX",
    address: "0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377.png",
    type: "token",
  },
  {
    name: "MiniFootball",
    symbol: "MINIFOOTBALL",
    address: "0xD024Ac1195762F6F13f8CfDF3cdd2c97b33B248b",
    chainId: 56,
    decimals: 9,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xD024Ac1195762F6F13f8CfDF3cdd2c97b33B248b/logo.png",
    type: "token",
  },
  {
    name: "Mist",
    symbol: "MIST",
    address: "0x68E374F856bF25468D365E539b700b648Bf94B67",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x68E374F856bF25468D365E539b700b648Bf94B67/logo.png",
    type: "token",
  },
  {
    name: "Mound Token",
    symbol: "MND",
    address: "0x4c97c901B5147F8C1C7Ce3c5cF3eB83B44F244fE",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x4c97c901B5147F8C1C7Ce3c5cF3eB83B44F244fE/logo.png",
    type: "token",
  },
  {
    name: "Monsta Infinite Token",
    symbol: "MONI",
    address: "0x9573c88aE3e37508f87649f87c4dd5373C9F31e0",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x9573c88aE3e37508f87649f87c4dd5373C9F31e0/logo.png",
    type: "token",
  },
  {
    name: "Nafter",
    symbol: "NAFT",
    address: "0xD7730681B1DC8f6F969166B29D8A5EA8568616a3",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xD7730681B1DC8f6F969166B29D8A5EA8568616a3/logo.png",
    type: "token",
  },
  {
    name: "Nobility",
    symbol: "NBL",
    address: "0xA67a13c9283Da5AABB199Da54a9Cb4cD8B9b16bA",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xA67a13c9283Da5AABB199Da54a9Cb4cD8B9b16bA/logo.png",
    type: "token",
  },
  {
    name: "NFTB",
    symbol: "NFTB",
    address: "0xde3dbBE30cfa9F437b293294d1fD64B26045C71A",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xde3dbBE30cfa9F437b293294d1fD64B26045C71A/logo.png",
    type: "token",
  },
  {
    name: "Nerve",
    symbol: "NRV",
    address: "0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096.png",
    type: "token",
  },
  {
    name: "Harmony ONE",
    symbol: "ONE",
    address: "0x03fF0ff224f904be3118461335064bB48Df47938",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x03fF0ff224f904be3118461335064bB48Df47938.png",
    type: "token",
  },
  {
    name: "PAID Network",
    symbol: "PAID",
    address: "0xAD86d0E9764ba90DDD68747D64BFfBd79879a238",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xAD86d0E9764ba90DDD68747D64BFfBd79879a238/logo.png",
    type: "token",
  },
  {
    name: "Pink Token",
    symbol: "PINK",
    address: "0x9133049Fb1FdDC110c92BF5b7Df635abB70C89DC",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x9133049Fb1FdDC110c92BF5b7Df635abB70C89DC/logo.png",
    type: "token",
  },
  {
    name: "Polkamon",
    symbol: "PMON",
    address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x1796ae0b0fa4862485106a0de9b654eFE301D0b2.png",
    type: "token",
  },
  {
    name: "Moonpot",
    symbol: "POTS",
    address: "0x3Fcca8648651E5b974DD6d3e50F61567779772A8",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x3Fcca8648651E5b974DD6d3e50F61567779772A8.png",
    type: "token",
  },
  {
    name: "Plant vs Undead Token",
    symbol: "PVU",
    address: "0x31471E0791fCdbE82fbF4C44943255e923F1b794",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x31471E0791fCdbE82fbF4C44943255e923F1b794/logo.png",
    type: "token",
  },
  {
    name: "PandaInu Wallet Token",
    symbol: "PWT",
    address: "0xf3eDD4f14a018df4b6f02Bf1b2cF17A8120519A2",
    chainId: 56,
    decimals: 8,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xf3eDD4f14a018df4b6f02Bf1b2cF17A8120519A2/logo.png",
    type: "token",
  },
  {
    name: "Qubit Token",
    symbol: "QBT",
    address: "0x17B7163cf1Dbd286E262ddc68b553D899B93f526",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x17B7163cf1Dbd286E262ddc68b553D899B93f526.png",
    type: "token",
  },
  {
    name: "Radio Caca V2",
    symbol: "RACA",
    address: "0x12BB890508c125661E03b09EC06E404bc9289040",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x12BB890508c125661E03b09EC06E404bc9289040/logo.png",
    type: "token",
  },
  {
    name: "RAMP DEFI",
    symbol: "RAMP",
    address: "0x8519EA49c997f50cefFa444d240fB655e89248Aa",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x8519EA49c997f50cefFa444d240fB655e89248Aa.png",
    type: "token",
  },
  {
    name: "Reef.finance",
    symbol: "REEF",
    address: "0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e.png",
    type: "token",
  },
  {
    name: "rUSD",
    symbol: "RUSD",
    address: "0x07663837218A003e66310a01596af4bf4e44623D",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x07663837218A003e66310a01596af4bf4e44623D.png",
    type: "token",
  },
  {
    name: "SafePal Token",
    symbol: "SFP",
    address: "0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb.png",
    type: "token",
  },
  {
    name: "SeedifyFund",
    symbol: "SFUND",
    address: "0x477bC8d23c634C154061869478bce96BE6045D12",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x477bC8d23c634C154061869478bce96BE6045D12.png",
    type: "token",
  },
  {
    name: "Shirtum",
    symbol: "SHI",
    address: "0x7269d98Af4aA705e0B1A5D8512FadB4d45817d5a",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x7269d98Af4aA705e0B1A5D8512FadB4d45817d5a/logo.png",
    type: "token",
  },
  {
    name: "CryptoBlades Skill Token",
    symbol: "SKILL",
    address: "0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab.png",
    type: "token",
  },
  {
    name: "StarMon",
    symbol: "SMON",
    address: "0xAB15B79880f11cFfb58dB25eC2bc39d28c4d80d2",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xAB15B79880f11cFfb58dB25eC2bc39d28c4d80d2/logo.png",
    type: "token",
  },
  {
    name: "Splintershards",
    symbol: "SPS",
    address: "0x1633b7157e7638C4d6593436111Bf125Ee74703F",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x1633b7157e7638C4d6593436111Bf125Ee74703F.png",
    type: "token",
  },
  {
    name: "SushiToken",
    symbol: "SUSHI",
    address: "0x947950BcC74888a40Ffa2593C5798F11Fc9124C4",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x947950BcC74888a40Ffa2593C5798F11Fc9124C4.png",
    type: "token",
  },
  {
    name: "Swipe",
    symbol: "SXP",
    address: "0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A.png",
    type: "token",
  },
  {
    name: "Tokocrypto Token",
    symbol: "TKO",
    address: "0x9f589e3eabe42ebC94A44727b3f3531C0c877809",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x9f589e3eabe42ebC94A44727b3f3531C0c877809.png",
    type: "token",
  },
  {
    name: "Alien Worlds Trilium",
    symbol: "TLM",
    address: "0x2222227E22102Fe3322098e4CBfE18cFebD57c95",
    chainId: 56,
    decimals: 4,
    logo: "https://tokens.pancakeswap.finance/images/0x2222227E22102Fe3322098e4CBfE18cFebD57c95.png",
    type: "token",
  },
  {
    name: "TokenPocket Token",
    symbol: "TPT",
    address: "0xECa41281c24451168a37211F0bc2b8645AF45092",
    chainId: 56,
    decimals: 4,
    logo: "https://tokens.pancakeswap.finance/images/0xECa41281c24451168a37211F0bc2b8645AF45092.png",
    type: "token",
  },
  {
    name: "TRONPAD.network",
    symbol: "TRONPAD",
    address: "0x1Bf7AedeC439D6BFE38f8f9b20CF3dc99e3571C4",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x1Bf7AedeC439D6BFE38f8f9b20CF3dc99e3571C4/logo.png",
    type: "token",
  },
  {
    name: "TRON",
    symbol: "TRX",
    address: "0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B.png",
    type: "token",
  },
  {
    name: "TrusterCoin",
    symbol: "TSC",
    address: "0xA2a26349448ddAfAe34949a6Cc2cEcF78c0497aC",
    chainId: 56,
    decimals: 9,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xA2a26349448ddAfAe34949a6Cc2cEcF78c0497aC/logo.png",
    type: "token",
  },
  {
    name: "TrueUSD",
    symbol: "TUSD",
    address: "0x14016E85a25aeb13065688cAFB43044C2ef86784",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x14016E85a25aeb13065688cAFB43044C2ef86784.png",
    type: "token",
  },
  {
    name: "Trust Wallet",
    symbol: "TWT",
    address: "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x4B0F1812e5Df2A09796481Ff14017e6005508003.png",
    type: "token",
  },
  {
    name: "UNCL on xDai on BSC",
    symbol: "UNCL",
    address: "0x0E8D5504bF54D9E44260f8d153EcD5412130CaBb",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x0E8D5504bF54D9E44260f8d153EcD5412130CaBb/logo.png",
    type: "token",
  },
  {
    name: "UniCrypt on xDai on BSC",
    symbol: "UNCX",
    address: "0x09a6c44c3947B69E2B45F4D51b67E6a39ACfB506",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x09a6c44c3947B69E2B45F4D51b67E6a39ACfB506/logo.png",
    type: "token",
  },
  {
    name: "Uniswap",
    symbol: "UNI",
    address: "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xBf5140A22578168FD562DCcF235E5D43A02ce9B1.png",
    type: "token",
  },
  {
    name: "Wrapped UST Token",
    symbol: "UST",
    address: "0x23396cF899Ca06c4472205fC903bDB4de249D6fC",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x23396cF899Ca06c4472205fC903bDB4de249D6fC.png",
    type: "token",
  },
  {
    name: "VAI Stablecoin",
    symbol: "VAI",
    address: "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7.png",
    type: "token",
  },
  {
    name: "Wanaka Farm",
    symbol: "WANA",
    address: "0x339C72829AB7DD45C3C52f965E7ABe358dd8761E",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x339C72829AB7DD45C3C52f965E7ABe358dd8761E/logo.png",
    type: "token",
  },
  {
    name: "WINk",
    symbol: "WIN",
    address: "0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99.png",
    type: "token",
  },
  {
    name: "XRP Token",
    symbol: "XRP",
    address: "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
    chainId: 56,
    decimals: 18,
    logo: "https://tokens.pancakeswap.finance/images/0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE.png",
    type: "token",
  },
  {
    name: "XWG",
    symbol: "XWG",
    address: "0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc/logo.png",
    type: "token",
  },
  {
    name: "YAY Games",
    symbol: "YAY",
    address: "0x524dF384BFFB18C0C8f3f43d012011F8F9795579",
    chainId: 56,
    decimals: 18,
    logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x524dF384BFFB18C0C8f3f43d012011F8F9795579/logo.png",
    type: "token",
  },
];

// export const getBaseTokenLogoURLByTokenSymbol = [
//   {
//     type: "coin",
//     chainId: 56,
//     value: "0x0000000000000000000000000000000000000000",
//     address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
//     name: "BNB",
//     label: "BNB",
//     decimals: 18,
//     logo: "data:image/png;base64,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",
//   },
//   {
//     name: "WBNB Token",
//     symbol: "WBNB",
//     address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c.png",
//     type: "token",
//   },
//   {
//     name: "PancakeSwap Token",
//     symbol: "CAKE",
//     address: "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82.png",
//     type: "token",
//   },
//   {
//     name: "Binance Pegged BUSD",
//     symbol: "BUSD",
//     address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56.png",
//     type: "token",
//   },
//   {
//     name: "Binance Pegged USDT",
//     symbol: "USDT",
//     address: "0x55d398326f99059fF775485246999027B3197955",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x55d398326f99059fF775485246999027B3197955.png",
//     type: "token",
//   },
//   {
//     name: "Binance Pegged Bitcoin",
//     symbol: "BTCB",
//     address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c.png",
//     type: "token",
//   },
//   {
//     name: "Binance Pegged ETH",
//     symbol: "ETH",
//     address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x2170Ed0880ac9A755fd29B2688956BD959F933F8.png",
//     type: "token",
//   },
//   {
//     name: "Bunny Token",
//     symbol: "BUNNY",
//     address: "0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51.png",
//     type: "token",
//   },
//   {
//     name: "Venus Token",
//     symbol: "XVS",
//     address: "0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63.png",
//     type: "token",
//   },
//   {
//     name: "Alpaca",
//     symbol: "ALPACA",
//     address: "0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F.png",
//     type: "token",
//   },
//   {
//     name: "Polkadot Token",
//     symbol: "DOT",
//     address: "0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402.png",
//     type: "token",
//   },
//   {
//     name: "Refinable",
//     symbol: "FINE",
//     address: "0x4e6415a5727ea08aAE4580057187923aeC331227",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x4e6415a5727ea08aAE4580057187923aeC331227.png",
//     type: "token",
//   },
//   {
//     name: "Binance Pegged DAI",
//     symbol: "DAI",
//     address: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3.png",
//     type: "token",
//   },
//   {
//     name: "Binance Pegged USD Coin",
//     symbol: "USDC",
//     address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d.png",
//     type: "token",
//   },
//   {
//     name: "Cardano Token",
//     symbol: "ADA",
//     address: "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47.png",
//   },
//   {
//     name: "ALICE",
//     symbol: "ALICE",
//     address: "0xAC51066d7bEC65Dc4589368da368b212745d63E8",
//     chainId: 56,
//     decimals: 6,
//     logo: "https://tokens.pancakeswap.finance/images/0xAC51066d7bEC65Dc4589368da368b212745d63E8.png",
//   },
//   {
//     name: "AlinX",
//     symbol: "ALIX",
//     address: "0xaF6Bd11A6F8f9c44b9D18f5FA116E403db599f8E",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xaF6Bd11A6F8f9c44b9D18f5FA116E403db599f8E/logo.png",
//   },
//   {
//     name: "AlphaToken",
//     symbol: "ALPHA",
//     address: "0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xa1faa113cbE53436Df28FF0aEe54275c13B40975.png",
//   },
//   {
//     name: "Altura",
//     symbol: "ALU",
//     address: "0x8263CD1601FE73C066bf49cc09841f35348e3be0",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8263CD1601FE73C066bf49cc09841f35348e3be0/logo.png",
//   },
//   {
//     name: "Automata",
//     symbol: "ATA",
//     address: "0xA2120b9e674d3fC3875f415A7DF52e382F141225",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xA2120b9e674d3fC3875f415A7DF52e382F141225.png",
//   },
//   {
//     name: "Cosmos Token",
//     symbol: "ATOM",
//     address: "0x0Eb3a705fc54725037CC9e008bDede697f62F335",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x0Eb3a705fc54725037CC9e008bDede697f62F335.png",
//   },
//   {
//     name: "Axie Infinity Shard",
//     symbol: "AXS",
//     address: "0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0.png",
//   },
//   {
//     name: "Baby Doge Coin",
//     symbol: "BABYDOGE",
//     address: "0xc748673057861a797275CD8A068AbB95A902e8de",
//     chainId: 56,
//     decimals: 9,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc748673057861a797275CD8A068AbB95A902e8de/logo.png",
//   },
//   {
//     name: "Bear",
//     symbol: "BEAR",
//     address: "0xc3EAE9b061Aa0e1B9BD3436080Dc57D2d63FEdc1",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc3EAE9b061Aa0e1B9BD3436080Dc57D2d63FEdc1/logo.png",
//   },
//   {
//     name: "Bella Protocol",
//     symbol: "BEL",
//     address: "0x8443f091997f06a61670B735ED92734F5628692F",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x8443f091997f06a61670B735ED92734F5628692F.png",
//   },
//   {
//     name: "BELT Token",
//     symbol: "BELT",
//     address: "0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f.png",
//   },
//   {
//     name: "Binemon",
//     symbol: "BIN",
//     address: "0xe56842Ed550Ff2794F010738554db45E60730371",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xe56842Ed550Ff2794F010738554db45E60730371/logo.png",
//   },
//   {
//     name: "Binamon",
//     symbol: "BMON",
//     address: "0x08ba0619b1e7A582E0BCe5BBE9843322C954C340",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x08ba0619b1e7A582E0BCe5BBE9843322C954C340.png",
//   },

//   {
//     name: "BunnyPark",
//     symbol: "BP",
//     address: "0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1.png",
//   },
//   {
//     name: "BSCPAD.com",
//     symbol: "BSCPAD",
//     address: "0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700.png",
//   },
//   {
//     name: "BitTorrent Old",
//     symbol: "BTTOLD",
//     address: "0x8595F9dA7b868b1822194fAEd312235E43007b49",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x8595F9dA7b868b1822194fAEd312235E43007b49.png",
//   },
//   {
//     name: "Coin98",
//     symbol: "C98",
//     address: "0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6.png",
//   },
//   {
//     name: "Chess",
//     symbol: "CHESS",
//     address: "0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6.png",
//   },
//   {
//     name: "Chroma",
//     symbol: "CHR",
//     address: "0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE",
//     chainId: 56,
//     decimals: 6,
//     logo: "https://tokens.pancakeswap.finance/images/0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE.png",
//   },
//   {
//     name: "CP",
//     symbol: "CP",
//     address: "0x82C19905B036bf4E329740989DCF6aE441AE26c1",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x82C19905B036bf4E329740989DCF6aE441AE26c1/logo.png",
//   },
//   {
//     name: "DeRace Token",
//     symbol: "DERC",
//     address: "0x373E768f79c820aA441540d254dCA6d045c6d25b",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x373E768f79c820aA441540d254dCA6d045c6d25b/logo.png",
//   },
//   {
//     name: "DODO bird",
//     symbol: "DODO",
//     address: "0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2.png",
//   },
//   {
//     name: "Dogecoin",
//     symbol: "DOGE",
//     address: "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
//     chainId: 56,
//     decimals: 8,
//     logo: "https://tokens.pancakeswap.finance/images/0xbA2aE424d960c26247Dd6c32edC70B295c744C43.png",
//   },
//   {
//     name: "My DeFi Pet Token",
//     symbol: "DPET",
//     address: "0xfb62AE373acA027177D1c18Ee0862817f9080d08",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xfb62AE373acA027177D1c18Ee0862817f9080d08/logo.png",
//   },

//   {
//     name: "DragonSlayer",
//     symbol: "DRS",
//     address: "0xc8E8ecB2A5B5d1eCFf007BF74d15A86434aA0c5C",
//     chainId: 56,
//     decimals: 9,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc8E8ecB2A5B5d1eCFf007BF74d15A86434aA0c5C/logo.png",
//   },
//   {
//     name: "Dvision",
//     symbol: "DVI",
//     address: "0x758FB037A375F17c7e195CC634D77dA4F554255B",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x758FB037A375F17c7e195CC634D77dA4F554255B.png",
//   },
//   {
//     name: "Etherconnect Coin",
//     symbol: "ECC",
//     address: "0x8D047F4F57A190C96c8b9704B39A1379E999D82B",
//     chainId: 56,
//     decimals: 8,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8D047F4F57A190C96c8b9704B39A1379E999D82B/logo.png",
//   },
//   {
//     name: "Ellipsis",
//     symbol: "EPS",
//     address: "0xA7f552078dcC247C2684336020c03648500C6d9F",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xA7f552078dcC247C2684336020c03648500C6d9F.png",
//   },
//   {
//     name: "FaraCrystal",
//     symbol: "FARA",
//     address: "0xF4Ed363144981D3A65f42e7D0DC54FF9EEf559A1",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xF4Ed363144981D3A65f42e7D0DC54FF9EEf559A1/logo.png",
//   },

//   {
//     name: "Formation Finance",
//     symbol: "FORM",
//     address: "0x25A528af62e56512A19ce8c3cAB427807c28CC19",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x25A528af62e56512A19ce8c3cAB427807c28CC19.png",
//   },
//   {
//     name: "Frontier Token",
//     symbol: "FRONT",
//     address: "0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b.png",
//   },

//   {
//     name: "StepHero",
//     symbol: "HERO",
//     address: "0xE8176d414560cFE1Bf82Fd73B986823B89E4F545",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xE8176d414560cFE1Bf82Fd73B986823B89E4F545.png",
//   },
//   {
//     name: "Metahero",
//     symbol: "HERO",
//     address: "0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13.png",
//   },
//   {
//     name: "Honey token",
//     symbol: "HONEY",
//     address: "0xFa363022816aBf82f18a9C2809dCd2BB393F6AC5",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xFa363022816aBf82f18a9C2809dCd2BB393F6AC5/logo.png",
//   },
//   {
//     name: "Hunny Token",
//     symbol: "HUNNY",
//     address: "0x565b72163f17849832A692A3c5928cc502f46D69",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x565b72163f17849832A692A3c5928cc502f46D69/logo.png",
//   },
//   {
//     name: "Injective Protocol",
//     symbol: "INJ",
//     address: "0xa2B726B1145A4773F68593CF171187d8EBe4d495",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xa2B726B1145A4773F68593CF171187d8EBe4d495.png",
//   },
//   {
//     name: "IoTeX Network",
//     symbol: "IOTX",
//     address: "0x9678E42ceBEb63F23197D726B29b1CB20d0064E5",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x9678E42ceBEb63F23197D726B29b1CB20d0064E5.png",
//   },
//   {
//     name: "Kaby Arena",
//     symbol: "KABY",
//     address: "0x02A40C048eE2607B5f5606e445CFc3633Fb20b58",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x02A40C048eE2607B5f5606e445CFc3633Fb20b58/logo.png",
//   },
//   {
//     name: "KmonCoin",
//     symbol: "KMON",
//     address: "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc732B6586A93b6B7CF5FeD3470808Bc74998224D/logo.png",
//   },
//   {
//     name: "Linear Token",
//     symbol: "LINA",
//     address: "0x762539b45A1dCcE3D36d080F74d1AED37844b878",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x762539b45A1dCcE3D36d080F74d1AED37844b878.png",
//   },
//   {
//     name: "ChainLink Token",
//     symbol: "LINK",
//     address: "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD.png",
//   },
//   {
//     name: "Mask Network",
//     symbol: "MASK",
//     address: "0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3.png",
//   },
//   {
//     name: "Mobox",
//     symbol: "MBOX",
//     address: "0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377.png",
//   },
//   {
//     name: "MiniFootball",
//     symbol: "MINIFOOTBALL",
//     address: "0xD024Ac1195762F6F13f8CfDF3cdd2c97b33B248b",
//     chainId: 56,
//     decimals: 9,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xD024Ac1195762F6F13f8CfDF3cdd2c97b33B248b/logo.png",
//   },
//   {
//     name: "Mist",
//     symbol: "MIST",
//     address: "0x68E374F856bF25468D365E539b700b648Bf94B67",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x68E374F856bF25468D365E539b700b648Bf94B67/logo.png",
//   },
//   {
//     name: "Mound Token",
//     symbol: "MND",
//     address: "0x4c97c901B5147F8C1C7Ce3c5cF3eB83B44F244fE",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x4c97c901B5147F8C1C7Ce3c5cF3eB83B44F244fE/logo.png",
//   },
//   {
//     name: "Monsta Infinite Token",
//     symbol: "MONI",
//     address: "0x9573c88aE3e37508f87649f87c4dd5373C9F31e0",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x9573c88aE3e37508f87649f87c4dd5373C9F31e0/logo.png",
//   },
//   {
//     name: "Nafter",
//     symbol: "NAFT",
//     address: "0xD7730681B1DC8f6F969166B29D8A5EA8568616a3",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xD7730681B1DC8f6F969166B29D8A5EA8568616a3/logo.png",
//   },
//   {
//     name: "Nobility",
//     symbol: "NBL",
//     address: "0xA67a13c9283Da5AABB199Da54a9Cb4cD8B9b16bA",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xA67a13c9283Da5AABB199Da54a9Cb4cD8B9b16bA/logo.png",
//   },
//   {
//     name: "NFTB",
//     symbol: "NFTB",
//     address: "0xde3dbBE30cfa9F437b293294d1fD64B26045C71A",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xde3dbBE30cfa9F437b293294d1fD64B26045C71A/logo.png",
//   },
//   {
//     name: "Nerve",
//     symbol: "NRV",
//     address: "0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096.png",
//   },
//   {
//     name: "Harmony ONE",
//     symbol: "ONE",
//     address: "0x03fF0ff224f904be3118461335064bB48Df47938",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x03fF0ff224f904be3118461335064bB48Df47938.png",
//   },
//   {
//     name: "PAID Network",
//     symbol: "PAID",
//     address: "0xAD86d0E9764ba90DDD68747D64BFfBd79879a238",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xAD86d0E9764ba90DDD68747D64BFfBd79879a238/logo.png",
//   },

//   {
//     name: "Pink Token",
//     symbol: "PINK",
//     address: "0x9133049Fb1FdDC110c92BF5b7Df635abB70C89DC",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x9133049Fb1FdDC110c92BF5b7Df635abB70C89DC/logo.png",
//   },
//   {
//     name: "Polkamon",
//     symbol: "PMON",
//     address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x1796ae0b0fa4862485106a0de9b654eFE301D0b2.png",
//   },

//   {
//     name: "Moonpot",
//     symbol: "POTS",
//     address: "0x3Fcca8648651E5b974DD6d3e50F61567779772A8",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x3Fcca8648651E5b974DD6d3e50F61567779772A8.png",
//   },
//   {
//     name: "Plant vs Undead Token",
//     symbol: "PVU",
//     address: "0x31471E0791fCdbE82fbF4C44943255e923F1b794",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x31471E0791fCdbE82fbF4C44943255e923F1b794/logo.png",
//   },
//   {
//     name: "PandaInu Wallet Token",
//     symbol: "PWT",
//     address: "0xf3eDD4f14a018df4b6f02Bf1b2cF17A8120519A2",
//     chainId: 56,
//     decimals: 8,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xf3eDD4f14a018df4b6f02Bf1b2cF17A8120519A2/logo.png",
//   },
//   {
//     name: "Qubit Token",
//     symbol: "QBT",
//     address: "0x17B7163cf1Dbd286E262ddc68b553D899B93f526",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x17B7163cf1Dbd286E262ddc68b553D899B93f526.png",
//   },
//   {
//     name: "Radio Caca V2",
//     symbol: "RACA",
//     address: "0x12BB890508c125661E03b09EC06E404bc9289040",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x12BB890508c125661E03b09EC06E404bc9289040/logo.png",
//   },
//   {
//     name: "RAMP DEFI",
//     symbol: "RAMP",
//     address: "0x8519EA49c997f50cefFa444d240fB655e89248Aa",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x8519EA49c997f50cefFa444d240fB655e89248Aa.png",
//   },
//   {
//     name: "Reef.finance",
//     symbol: "REEF",
//     address: "0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e.png",
//   },
//   {
//     name: "rUSD",
//     symbol: "RUSD",
//     address: "0x07663837218A003e66310a01596af4bf4e44623D",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x07663837218A003e66310a01596af4bf4e44623D.png",
//   },
//   {
//     name: "SafePal Token",
//     symbol: "SFP",
//     address: "0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb.png",
//   },
//   {
//     name: "SeedifyFund",
//     symbol: "SFUND",
//     address: "0x477bC8d23c634C154061869478bce96BE6045D12",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x477bC8d23c634C154061869478bce96BE6045D12.png",
//   },
//   {
//     name: "Shirtum",
//     symbol: "SHI",
//     address: "0x7269d98Af4aA705e0B1A5D8512FadB4d45817d5a",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x7269d98Af4aA705e0B1A5D8512FadB4d45817d5a/logo.png",
//   },
//   {
//     name: "CryptoBlades Skill Token",
//     symbol: "SKILL",
//     address: "0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab.png",
//   },
//   {
//     name: "StarMon",
//     symbol: "SMON",
//     address: "0xAB15B79880f11cFfb58dB25eC2bc39d28c4d80d2",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xAB15B79880f11cFfb58dB25eC2bc39d28c4d80d2/logo.png",
//   },
//   {
//     name: "Splintershards",
//     symbol: "SPS",
//     address: "0x1633b7157e7638C4d6593436111Bf125Ee74703F",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x1633b7157e7638C4d6593436111Bf125Ee74703F.png",
//   },
//   {
//     name: "SushiToken",
//     symbol: "SUSHI",
//     address: "0x947950BcC74888a40Ffa2593C5798F11Fc9124C4",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x947950BcC74888a40Ffa2593C5798F11Fc9124C4.png",
//   },
//   {
//     name: "Swipe",
//     symbol: "SXP",
//     address: "0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A.png",
//   },
//   {
//     name: "Tokocrypto Token",
//     symbol: "TKO",
//     address: "0x9f589e3eabe42ebC94A44727b3f3531C0c877809",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x9f589e3eabe42ebC94A44727b3f3531C0c877809.png",
//   },
//   {
//     name: "Alien Worlds Trilium",
//     symbol: "TLM",
//     address: "0x2222227E22102Fe3322098e4CBfE18cFebD57c95",
//     chainId: 56,
//     decimals: 4,
//     logo: "https://tokens.pancakeswap.finance/images/0x2222227E22102Fe3322098e4CBfE18cFebD57c95.png",
//   },
//   {
//     name: "TokenPocket Token",
//     symbol: "TPT",
//     address: "0xECa41281c24451168a37211F0bc2b8645AF45092",
//     chainId: 56,
//     decimals: 4,
//     logo: "https://tokens.pancakeswap.finance/images/0xECa41281c24451168a37211F0bc2b8645AF45092.png",
//   },
//   {
//     name: "TRONPAD.network",
//     symbol: "TRONPAD",
//     address: "0x1Bf7AedeC439D6BFE38f8f9b20CF3dc99e3571C4",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x1Bf7AedeC439D6BFE38f8f9b20CF3dc99e3571C4/logo.png",
//   },
//   {
//     name: "TRON",
//     symbol: "TRX",
//     address: "0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B.png",
//   },
//   {
//     name: "TrusterCoin",
//     symbol: "TSC",
//     address: "0xA2a26349448ddAfAe34949a6Cc2cEcF78c0497aC",
//     chainId: 56,
//     decimals: 9,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xA2a26349448ddAfAe34949a6Cc2cEcF78c0497aC/logo.png",
//   },
//   {
//     name: "TrueUSD",
//     symbol: "TUSD",
//     address: "0x14016E85a25aeb13065688cAFB43044C2ef86784",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x14016E85a25aeb13065688cAFB43044C2ef86784.png",
//   },
//   {
//     name: "Trust Wallet",
//     symbol: "TWT",
//     address: "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x4B0F1812e5Df2A09796481Ff14017e6005508003.png",
//   },
//   {
//     name: "UNCL on xDai on BSC",
//     symbol: "UNCL",
//     address: "0x0E8D5504bF54D9E44260f8d153EcD5412130CaBb",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x0E8D5504bF54D9E44260f8d153EcD5412130CaBb/logo.png",
//   },
//   {
//     name: "UniCrypt on xDai on BSC",
//     symbol: "UNCX",
//     address: "0x09a6c44c3947B69E2B45F4D51b67E6a39ACfB506",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x09a6c44c3947B69E2B45F4D51b67E6a39ACfB506/logo.png",
//   },
//   {
//     name: "Uniswap",
//     symbol: "UNI",
//     address: "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xBf5140A22578168FD562DCcF235E5D43A02ce9B1.png",
//   },
//   {
//     name: "Wrapped UST Token",
//     symbol: "UST",
//     address: "0x23396cF899Ca06c4472205fC903bDB4de249D6fC",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x23396cF899Ca06c4472205fC903bDB4de249D6fC.png",
//   },
//   {
//     name: "VAI Stablecoin",
//     symbol: "VAI",
//     address: "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7.png",
//   },
//   {
//     name: "Wanaka Farm",
//     symbol: "WANA",
//     address: "0x339C72829AB7DD45C3C52f965E7ABe358dd8761E",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x339C72829AB7DD45C3C52f965E7ABe358dd8761E/logo.png",
//   },

//   {
//     name: "WINk",
//     symbol: "WIN",
//     address: "0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99.png",
//   },
//   {
//     name: "XRP Token",
//     symbol: "XRP",
//     address: "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://tokens.pancakeswap.finance/images/0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE.png",
//   },
//   {

//     name: "XWG",
//     symbol: "XWG",
//     address: "0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc/logo.png",
//   },
//   {
//     name: "YAY Games",
//     symbol: "YAY",
//     address: "0x524dF384BFFB18C0C8f3f43d012011F8F9795579",
//     chainId: 56,
//     decimals: 18,
//     logo: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x524dF384BFFB18C0C8f3f43d012011F8F9795579/logo.png",
//   },
// ];
